import React from "react";
import Joyride from 'react-joyride';

import fig_vis from './fig_dataVis.jpg'

export function OnBoard() {

  return <Joyride
    showProgress={true}
    showSkipButton={true}
    continuous={true}
    styles={{
      tooltip: {
        fontSize: 24,
        fontFamily: 'Comic Sans MS'
      },
      tooltipTitle: {
        fontSize: 28,
        fontWeight: 500,
      },
    }}
    steps={[
      {
        target: '.visualizationContainer',
        title: 'Visualizing the player\'s in-game data',
        content: <img alt="The intro of the vis" src={fig_vis}></img>,
        placement: 'center',
        styles: {
          options: {
            width: 1200
          }
        }
      },
      {
        target: '.visualizationContainer',
        title: 'Use your mouse to hover on the players to interact with them!',
        content: <video autoPlay loop src={`${process.env.PUBLIC_URL}/intro_mouse hover.mp4`}></video>,
        placement: 'center',
        styles: {
          options: {
            width: 1000
          }
        }
      },
      {
        target: '.comment-box',
        content: 'Type your comments here!',
        disableBeacon: true,
      },
      {
        target: '.comment-box',
        title: 'You can use `#` to auto-complete player names, and highlight them in the video!',
        content: <video autoPlay loop src={`${process.env.PUBLIC_URL}/intro_text highlight.mp4`}></video>,
        placement: 'center',
        disableScrolling: true,
        styles: {
          options: { width: 1100 }
        },
        disableBeacon: true
      },
      {
        target: '.featurePanel',
        content: 'Use this panel to toggle on/off features.',
        placement: 'auto',
        disableBeacon: true
      },
      {
        target: '.playerPanel',
        content: 'Use this panel to specify how to highlight players.',
        placement: 'auto',
        disableBeacon: true
      },
      {
        target: '#playpause',
        content: 'Now let\'s play the game!',
        disableBeacon: true
      }
    ]}></Joyride>
}